import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";

import { companyActions, storeActions } from "../../../redux/actions";
import Topbar from "../../../shared/components/topbar/Topbar";
import Button from "../../../shared/components/Buttons/Button";
import SelectField from "../../../shared/components/selectField/SelectField";
import SwitchButton from "../../../shared/components/SwitchButton/SwitchButton";
import SwitchButtonFormik from "../../../shared/components/SwitchButton/SwitchButtonFormik";
import InputTextField from "../../../shared/components/inputTextField/InputTextField";
import StoreAddressFields from "../../../shared/components/store/StoreAddressFields";
import InputNumberField from "../../../shared/components/inputNumberField/InputNumberField";
import {
  addStoreAsCompanyValidationSchema,
  addStoreValidationSchema,
} from "../../../shared/validationSchema/validationSchema";
import PhoneInputField from "../../../shared/components/phoneInputField/PhoneInputField";
import {
  storeConstants,
  buttonNameConstants,
  buttonTypeConstants,
  routesPathConstants,
  companyConstants,
  toggleSwitchButtonConstants,
  EMPTY_STRING,
} from "../../../constants";
import InputPasswordField from "../../../shared/components/inputPasswordField/InputPasswordField";
import LeadsOnlineForm from "../../../shared/components/store/LeadsOnlineForm";
import {
  createCompanyDynamicUrl,
  isSpinnerEnabled,
  getStoreAddressInitialValues,
  getStoreAddressPayload,
} from "../../../shared/utility";
import { BILLING_TYPES_ENUMS } from "../../../system/globalEnums";

const AddStore = (props) => {
  const [isStoreActive, setIsStoreActive] = useState(true);
  const [isCompanyStore, setIsCompanyStore] = useState(true);
  const navigate = useNavigate();
  const initialValues = {
    ...getStoreAddressInitialValues(),
    owner: [],
    storeName: "",
    defaultTax: "",
    phoneNumber: "",
    connectionTo: "",
    billingAmount: "0.00", // string make sure we don' get required validation on free access billing type
    freeTrialLength: "0", // string make sure we don' get required validation on free access billing type
    email: "",
    password: "",
    companyId: "",
    ownerNamePlaceholder: "",
    isDummyCompany: false,
    activeCardPaymentType: storeConstants.STORE_TYPE[0].value,
    billingType: storeConstants.BILLING_TYPE[0].value,
    domainUrl: EMPTY_STRING,
    isShopifyIntegration: false,
    isLeadsOnlineIntegration: false,
    leadsOnlineStoreId: EMPTY_STRING,
    leadsOnlineUsername: EMPTY_STRING,
    leadsOnlinePassword: EMPTY_STRING,
    isTcgPlayerButtonDisabled: false,
  };
  const { spinnerArray } = props;
  const { companies } = props.company;
  const handleSubmit = async (data) => {
    let dataToSend = {
      ...getStoreAddressPayload(data),
      showOnLabels: false,
      showOnReceipt: false,
      storeName: data.storeName,
      defaultTax: data.defaultTax,
      isStoreActive: isStoreActive,
      isShopifyIntegration: data.isShopifyIntegration,
      isLeadsOnlineIntegration: data.isLeadsOnlineIntegration,
      phoneNumber: data.phoneNumber,
      billingType: data.billingType,
      connectionTo: data.connectionTo,
      isDummyCompany: !isCompanyStore,
      billingAmount: data.billingAmount,
      logo: EMPTY_STRING,
      returnPolicy: EMPTY_STRING,
      activeCardPaymentType: data.activeCardPaymentType,
      [toggleSwitchButtonConstants.IS_SALE_OUT_OF_STOCK]: false,
      [toggleSwitchButtonConstants.IS_ID_REQUIRED_TRADE_IN]: false,
      [toggleSwitchButtonConstants.IS_SERIAL_NUMBER_REQUIRED_INVENTORY]: false,
      companyId: !isCompanyStore
        ? companyConstants.CREATE_DUMMY_COMPANY
        : data.companyId,
      isQrCodeOnSaleReceipt: false,
      isQrCodeOnTradeReceipt: false,
      qrCodeUrl: EMPTY_STRING,
      qrCodeDescription: EMPTY_STRING,
      billing: {
        freeTrialLength: data.freeTrialLength,
      },
      leadsOnlineStoreId: data.leadsOnlineStoreId,
      leadsOnlineUsername: data.leadsOnlineUsername,
      leadsOnlinePassword: data.leadsOnlinePassword,
      isTcgPlayerButtonDisabled: false,
    };
    if (!isCompanyStore) {
      dataToSend = {
        ...dataToSend,
        companyMetaData: {
          email: data.email,
          password: data.password,
          ownerNamePlaceholder: data.ownerNamePlaceholder,
        },
      };
    }
    props.addStore(dataToSend);
  };

  const handleStoreActiveChange = (id, value) => {
    setIsStoreActive(value);
  };

  const handleIsCompanyStoreChange = (id, value, setFieldValue) => {
    setIsCompanyStore(value);
    setFieldValue("companyId", "");
  };

  useEffect(() => {
    props.getStoreOwners();
    props.getCompanies();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Topbar
        title={"New Store"}
        backNavigation={{
          isVisible: true,
          route: routesPathConstants.ADMIN_STORES,
        }}
      />
      <Row className="m-0 w-100 user-information-wrapper container-scrollbar">
        <Formik
          initialValues={initialValues}
          validate={
            isCompanyStore
              ? addStoreValidationSchema
              : addStoreAsCompanyValidationSchema
          }
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue }) => (
            <Form className="px-0">
              <Row className="m-0">
                <Col md={6} className="mb-3">
                  <InputTextField
                    name="storeName"
                    placeHolder="Enter Store Name"
                    label="Store Name"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <PhoneInputField
                    name="phoneNumber"
                    label="Phone Number"
                    defaultCountry={values.countryCode}
                    isSupportedCountriesOnly={true}
                  />
                </Col>
                <StoreAddressFields />
                <Col md={6} className="mb-3">
                  <InputNumberField
                    name="defaultTax"
                    label="Default Tax (%)"
                    placeHolder="00"
                    type="number"
                  />
                </Col>
                <Col md={6}>
                  <SelectField
                    label="Billing Type"
                    name="billingType"
                    placeHolder={"Select Biling Type"}
                    options={storeConstants.BILLING_TYPE}
                    isSearchable={false}
                  />
                </Col>
                <Col
                  md={3}
                  className={`mb-3 
                    ${
                      values.billingType === BILLING_TYPES_ENUMS.FREE_ACCESS &&
                      "invisible"
                    }`}
                >
                  <InputNumberField
                    name="billingAmount"
                    label="Billing Amount"
                    placeHolder="00"
                    type="number"
                  />
                </Col>
                <Col
                  md={3}
                  className={`mb-3 
                    ${
                      values.billingType === BILLING_TYPES_ENUMS.FREE_ACCESS &&
                      "invisible"
                    }`}
                >
                  <InputNumberField
                    name="freeTrialLength"
                    label="Free Trial Length (Days)"
                    placeHolder="0"
                    step="1"
                    type="number"
                    isConvertToWhole={true}
                    maxValue={999999}
                  />
                </Col>
                <Col md={6}>
                  <SelectField
                    label="Store Type"
                    name="activeCardPaymentType"
                    placeHolder={"Select Store Type"}
                    options={storeConstants.STORE_TYPE}
                    isSearchable={false}
                  />
                </Col>
                <Col
                  md={6}
                  className="d-flex align-items-end py-md-2 mt-2 gap-3"
                >
                  <SwitchButton
                    onSwitchChange={handleStoreActiveChange}
                    label={"Active"}
                    id="storeActiveSwitch"
                    isSwitchOn={isStoreActive}
                  />
                  <SwitchButton
                    onSwitchChange={(id, value) =>
                      handleIsCompanyStoreChange(id, value, setFieldValue)
                    }
                    label={"Company Store"}
                    id="isCompanySoreSwitch"
                    isSwitchOn={isCompanyStore}
                  />
                  <SwitchButtonFormik
                    setFieldValue={setFieldValue}
                    name="isShopifyIntegration"
                    label={"Shopify Integration"}
                    isChecked={values.isShopifyIntegration}
                  />
                  <SwitchButtonFormik
                    setFieldValue={setFieldValue}
                    name="isLeadsOnlineIntegration"
                    label={"Leads Online Integration"}
                    isChecked={values["isLeadsOnlineIntegration"]}
                  />
                </Col>
                {isCompanyStore ? (
                  <>
                    <Col md={6} className="mt-2 ">
                      <SelectField
                        label="Company"
                        name="companyId"
                        placeHolder={"Select Company..."}
                        options={
                          companies?.map((company) => ({
                            value: company.id,
                            label: company.companyName,
                          })) || []
                        }
                      />
                    </Col>
                    <Col md={6}></Col>
                  </>
                ) : (
                  <>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        name="email"
                        label="Email"
                        placeHolder="Enter Email"
                      />
                    </Col>
                    <Col md={6} className="mb-3 d-flex gap-2">
                      <InputPasswordField
                        name="password"
                        label="Password"
                        placeHolder="Enter Password"
                        className="w-100"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        name="ownerNamePlaceholder"
                        placeHolder="Enter Owner Name"
                        label="Owner Name"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <InputTextField
                        name="domainUrl"
                        label="Domain Url"
                        placeHolder={"Auto Generated"}
                        disabled={true}
                      />
                    </Col>
                  </>
                )}
                {values.isLeadsOnlineIntegration && <LeadsOnlineForm />}
              </Row>
              <Row className="m-0 w-100 user-information-wrapper container-scrollbar">
                <Col md={6} className="my-3 d-flex gap-2">
                  <Button
                    type="button"
                    label={buttonNameConstants.CANCEL}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    className="w-100"
                    handleClick={() =>
                      navigate(
                        createCompanyDynamicUrl(
                          routesPathConstants.ADMIN_STORES
                        )
                      )
                    }
                    isDisabled={isSpinnerEnabled(
                      spinnerArray,
                      storeConstants.ADD_STORE
                    )}
                  ></Button>
                  <Button
                    type="submit"
                    className="w-100"
                    label={buttonNameConstants.SAVE}
                    isDisabled={isSpinnerEnabled(
                      spinnerArray,
                      storeConstants.ADD_STORE
                    )}
                  ></Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Row>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  company: state.company,
  user: state.authentication.user,
  storeOwners: state.store.storeOwners,
  spinnerArray: state.system.spinnerArray,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addStore: (data) => dispatch(storeActions.addStore(data)),
  getStoreOwners: () => dispatch(storeActions.getStoreOwners()),
  getCompanies: () => dispatch(companyActions.getAllCompanies()),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(AddStore);
